import {
  blogEmpresarialArticles,
  blogEmpresarialCategories,
} from "./blogEmpresarialContent";
import { blogEmpresarialArticulosBodyEn } from "./blogEmpresarialArticulosBodyEn";
import { blogEmpresarialTemas } from "./blogEmpresarialTemas";

const AUTHOR_EN = "MEU Aliado Empresas Team";

const uiEs = {
  badge: "Blog",
  heroTitle: "Negocios",
  heroSubtitle:
    "Lleve su empresa al siguiente nivel. Explore estrategias, tendencias y buenas prácticas para impulsar la gestión financiera, la operación y el crecimiento de su negocio.",
  heroImageAlt: "Profesionales revisando estrategia empresarial",
  filterTitle: "Puede filtrar por tema",
  filterSubtitle: "¿Qué quiere encontrar hoy?",
  verMenosTemas: "Ver menos temas",
  verTodosTemas: "Ver todos los temas",
  filtrando: "Filtrando:",
  quitarFiltro: "Quitar filtro",
  loUltimo: "Lo último",
  populares: "Populares",
  leerArticulo: "Leer artículo",
  verMasArticulos: "Ver más artículos",
  masTemas: "Más temas para ti 👆",
  lecturaDe: "Lectura de",
  minutos: "min",
  categoriaDefault: "Negocios",
  sinArticulosTitle: "Estamos preparando nuevos contenidos",
  sinArticulosBody:
    "Pronto publicaremos artículos sobre gestión empresarial, finanzas corporativas y estrategia. Vuelva a visitarnos.",
  sinArticulosFiltrado: "No hay artículos en este tema todavía.",
  blogEmpresarial: "Blog Empresarial",
  byAuthor: "Por",
  keyTakeawaysTitle: "Puntos clave para recordar",
  readFullArticle: "Leer artículo completo",
  readArticle: "Leer artículo",
  articleNotFoundTitle: "No encontramos este artículo",
  articleNotFoundBody:
    "Es posible que el artículo haya sido movido. Regrese al Blog Empresarial para explorar contenidos recientes.",
  goToBlog: "Ir al blog empresarial",
  viewCategory: "Ver categoría",
  alsoMayInterest: "También le puede interesar",
  moreArticlesIn: "Más artículos en",
  viewAll: "Ver todos",
  categoryNotFoundTitle: "Tema no encontrado",
  backToBlog: "Volver al blog empresarial",
  categoryEmpty: "Pronto habrá artículos en esta categoría.",
  sliderBadge: "Selección especial",
  sliderTitle: "Artículos que están dando de qué hablar",
  prevArticle: "Artículo anterior",
  nextArticle: "Siguiente artículo",
};

const uiEn = {
  badge: "Blog",
  heroTitle: "Business",
  heroSubtitle:
    "Take your company to the next level. Explore strategies, trends, and best practices to strengthen financial management, operations, and business growth.",
  heroImageAlt: "Professionals reviewing business strategy",
  filterTitle: "Filter by topic",
  filterSubtitle: "What are you looking for today?",
  verMenosTemas: "Show fewer topics",
  verTodosTemas: "Show all topics",
  filtrando: "Filtering:",
  quitarFiltro: "Clear filter",
  loUltimo: "Latest",
  populares: "Popular",
  leerArticulo: "Read article",
  verMasArticulos: "View more articles",
  masTemas: "More topics for you 👆",
  lecturaDe: "Read time",
  minutos: "min",
  categoriaDefault: "Business",
  sinArticulosTitle: "We're preparing new content",
  sinArticulosBody:
    "We'll soon publish articles on business management, corporate finance, and strategy. Check back soon.",
  sinArticulosFiltrado: "No articles in this topic yet.",
  blogEmpresarial: "Business Blog",
  byAuthor: "By",
  keyTakeawaysTitle: "Key takeaways",
  readFullArticle: "Read full article",
  readArticle: "Read article",
  articleNotFoundTitle: "We couldn't find this article",
  articleNotFoundBody:
    "The article may have been moved. Return to the Business Blog to explore recent content.",
  goToBlog: "Go to business blog",
  viewCategory: "View category",
  alsoMayInterest: "You may also like",
  moreArticlesIn: "More articles in",
  viewAll: "View all",
  categoryNotFoundTitle: "Topic not found",
  backToBlog: "Back to business blog",
  categoryEmpty: "Articles in this category are coming soon.",
  sliderBadge: "Featured picks",
  sliderTitle: "Articles making waves",
  prevArticle: "Previous article",
  nextArticle: "Next article",
};

const categoriesEn = {
  "gestion-administrativa": {
    title: "Administrative management",
    subtitle: "Governance, operations, and planning best practices for leadership teams.",
  },
  "transformacion-digital": {
    title: "Digital transformation",
    subtitle: "Automation, data, and AI applied to real business processes.",
  },
  "finanzas-corporativas": {
    title: "Corporate finance",
    subtitle: "Treasury, working capital, and tools to sustain company liquidity.",
  },
  "estrategia-comercial": {
    title: "Commercial strategy",
    subtitle: "Pricing, international markets, and profitability-driven commercial decisions.",
  },
};

const temasEn = {
  Administración: "Administration",
  "Comercio internacional": "International trade",
  "E-commerce": "E-commerce",
  Emprendimiento: "Entrepreneurship",
  "Finanzas empresariales": "Business finance",
  "Gestión empresarial": "Business management",
  "Gestión de riesgo": "Risk management",
  "Gestión de procesos": "Process management",
  "Gestión humana": "People management",
  Innovación: "Innovation",
  Legal: "Legal",
  Seguros: "Insurance",
  "Datos y analítica": "Data & analytics",
};

const articlesEn = {
  "proceso-disciplinario-reforma-laboral-2026": {
    title: "Disciplinary procedures: how to align them with Colombia's 2025 labor reform",
    excerpt:
      "Law 2466 requires updating your Internal Work Regulations by June 25, 2026 with a full disciplinary procedure. Learn key principles, stages, common mistakes, and how to communicate the rules without legal risk.",
    date: "April 20, 2026",
    readTime: "9 min",
  },
  "contrato-aprendizaje-practicas-empresas-2026": {
    title: "Apprenticeship and internship contracts in 2026: a guide for businesses",
    excerpt:
      "Colombia's 2025 labor reform and Decree 0223 of 2026 redefine how companies hire SENA apprentices and university interns. Learn obligations, costs, quotas, and best practices.",
    date: "April 13, 2026",
    readTime: "9 min",
  },
  "plan-atraccion-talento-sostenible-negocio": {
    title: "How to design a sustainable talent attraction plan for your business",
    excerpt:
      "The «no talent available» complaint often hides a weak hiring process. Build a results-driven system with leadership alignment and strategies that cut turnover and cost.",
    date: "March 17, 2026",
    readTime: "8 min",
  },
  "convenios-doble-tributacion-empresas-colombia": {
    title: "Double taxation treaties: how to use them in cross-border operations",
    excerpt:
      "CDTs allocate tax liability between countries and may lower withholding on dividends, services, and interest. Learn requirements, practical cases, and mistakes that jeopardize deductions.",
    date: "February 24, 2026",
    readTime: "10 min",
  },
  "planeacion-tributaria-calendario-2026": {
    title: "Tax planning 2026: build your fiscal calendar and protect cash flow",
    excerpt:
      "When accounting runs on deadline panic, planning failed. Learn key benefits, major taxes, environmental levies, and how to align bookkeeping, treasury, and your 2026 tax calendar.",
    date: "February 12, 2026",
    readTime: "10 min",
  },
  "tendencias-credito-acceso-financiero-pymes": {
    title: "Credit trends driving financial access for SMEs in 2026",
    excerpt:
      "Digital banking and fintech are widening SME credit, but the financing gap remains huge. Learn key trends, how credit is used, and how to prepare your company for funding.",
    date: "February 2, 2026",
    readTime: "9 min",
  },
  "costos-logisticos-cadena-abastecimiento-empresas": {
    title: "Logistics costs and supply chain: impacts on your business profitability",
    excerpt:
      "Outsourcing logistics without knowing cost breakdowns hides savings opportunities. Identify direct and hidden costs, weigh in-house vs. third-party options, and protect your margin.",
    date: "December 29, 2025",
    readTime: "8 min",
  },
  "ajustes-economicos-planeacion-financiera-2026": {
    title: "2026 economic adjustments: 4 indicators that shape your financial planning",
    excerpt:
      "CPI, UVT, UVB, and minimum wage redefine payroll, rent, utilities, and tax costs. Learn how to project them before closing your 2026 budget and avoid cash flow surprises.",
    date: "December 30, 2025",
    readTime: "9 min",
  },
  "estrategias-recaudo-cartera-finanzas-empresas": {
    title: "Accounts receivable strategies to strengthen your company's liquidity",
    excerpt:
      "The cash you need may be stuck in unpaid invoices. Learn credit risk prevention, proactive collection, overdue recovery, and executive arbitration from 2026.",
    date: "December 16, 2025",
    readTime: "9 min",
  },
  "obligaciones-financieras-cierre-anual-empresas": {
    title: "Year-end financial obligations: closing guide and 2026 calendar",
    excerpt:
      "Between holiday sales and time off, don't lose sight of inventory, VAT, severance pay, business registration, and filings due in early 2026. Build your calendar now.",
    date: "December 3, 2025",
    readTime: "9 min",
  },
};

export function getBlogEmpresarialBundle(lang) {
  const ui = lang === "en" ? uiEn : uiEs;

  const categories = Object.fromEntries(
    Object.entries(blogEmpresarialCategories).map(([slug, cat]) => [
      slug,
      {
        ...cat,
        title: lang === "en" ? categoriesEn[slug]?.title ?? cat.title : cat.title,
        subtitle: lang === "en" ? categoriesEn[slug]?.subtitle ?? cat.subtitle : cat.subtitle,
      },
    ])
  );

  const temas = blogEmpresarialTemas.map((tema) => ({
    ...tema,
    label: lang === "en" ? temasEn[tema.label] ?? tema.label : tema.label,
  }));

  const articles = blogEmpresarialArticles.map((article) => {
    if (lang !== "en") return article;

    const meta = articlesEn[article.slug];
    const body = blogEmpresarialArticulosBodyEn[article.slug];
    if (!meta && !body) return article;

    return {
      ...article,
      ...(meta
        ? {
            title: meta.title,
            excerpt: meta.excerpt,
            date: meta.date,
          }
        : {}),
      readTime: body?.readTime ?? meta?.readTime ?? article.readTime,
      author: AUTHOR_EN,
      ...(body?.keyTakeaways ? { keyTakeaways: body.keyTakeaways } : {}),
      ...(body?.content ? { content: body.content } : {}),
    };
  });

  return { ui, categories, temas, articles };
}
